export enum ConnectionState {
  Unknown = 'Unknown',
  Activating = 'Activating',
  Activated = 'Activated',
  Deactivating = 'Deactivating',
  Deactivated = 'Deactivated',
}


export const ConnectionStateLabel: Map<ConnectionState, string> = new Map([
  [ConnectionState.Unknown, 'Unknown'],
  [ConnectionState.Activating, 'Connecting'],
  [ConnectionState.Activated, 'Connected'],
  [ConnectionState.Deactivating, 'Disconnecting'],
  [ConnectionState.Deactivated, 'Disconnected'],
]);


export const ConnectionStateColor: Map<ConnectionState, string> = new Map([
  [ConnectionState.Unknown, 'gray'],
  [ConnectionState.Activating, 'blue'],
  [ConnectionState.Activated, 'success'],
  [ConnectionState.Deactivating, 'blue'],
  [ConnectionState.Deactivated, 'gray'],
]);
